import styled from "styled-components/native";
import { spacing } from "../theme";
import { listFlexProps } from "./list";

export const ListHeader = styled.View`
  padding: 0 ${spacing.large} ${spacing.medium};

  ${listFlexProps};
`;
